var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CustomFormElement } from 'components';
import { licenseModalConstants } from 'lib/constants';
import LicenseHeader from './LicenseHeader';
import LicenseFooter from './LicenseFooter';
import { fetchSalesRepresentativesList, fetchCounties, fetchMunicipalities, createLicense, fetchSalesRepresentativeLicenses, uploadLicenseAttachment, updateLicense, deleteLicenseAttachment, previewLicenseAttachment, downloadLicenseAttachment } from 'services';
import * as yup from 'yup';
import { formatDate } from 'lib/utils';
import moment from 'moment';
import { capitalize } from 'lodash';
var NEW_LICENSE = licenseModalConstants.NEW_LICENSE, EDIT_LICENSE = licenseModalConstants.EDIT_LICENSE, REP_LABEL = licenseModalConstants.REP_LABEL, STATE_LABEL = licenseModalConstants.STATE_LABEL, COUNTY_LABEL = licenseModalConstants.COUNTY_LABEL, MUNICIPALITY_LABEL = licenseModalConstants.MUNICIPALITY_LABEL, LICENSE_NUMBER_LABEL = licenseModalConstants.LICENSE_NUMBER_LABEL, LICENSE_NUMBER_PLACEHOLDER = licenseModalConstants.LICENSE_NUMBER_PLACEHOLDER, START_DATE_LABEL = licenseModalConstants.START_DATE_LABEL, SUBMISSION_DATE_LABEL = licenseModalConstants.SUBMISSION_DATE_LABEL, EXPIRATION_DATE_LABEL = licenseModalConstants.EXPIRATION_DATE_LABEL, ISSUED_DATE_LABEL = licenseModalConstants.ISSUED_DATE_LABEL, NOTES_LABEL = licenseModalConstants.NOTES_LABEL, NOTES_PLACEHOLDER = licenseModalConstants.NOTES_PLACEHOLDER, ATTACHMENTS_LABEL = licenseModalConstants.ATTACHMENTS_LABEL, ATTACHMENTS_DESCRIPTION = licenseModalConstants.ATTACHMENTS_DESCRIPTION;
var newLicenseSchema = yup.object().shape({
    state_abbr: yup.string().required('Field must be selected.'),
    issued_date: yup.string().required('Field must be selected.'),
    expiration_date: yup.string().required('Field must be selected.'),
    sales_reps_ids: yup
        .array()
        .of(yup.number().required('Each sales rep ID must be a number.'))
        .required('Field must be selected.')
        .min(1, 'Field must be selected.'),
});
var editLicenseSchema = yup.object().shape({
    state_abbr: yup.string().required('Field must be selected.'),
    issued_date: yup.string().required('Field must be selected.'),
    expiration_date: yup.string().required('Field must be selected.'),
});
var LicenseForm = function (_a) {
    var _b, _c;
    var license = _a.license, onClose = _a.onClose, states = _a.states, salesRepresentative = _a.salesRepresentative, setSalesRepresentativeLicenses = _a.setSalesRepresentativeLicenses, selectedLicenseAttachments = _a.selectedLicenseAttachments;
    var _d = useState([]), salesRepresentatives = _d[0], setSalesRepresentatives = _d[1];
    var _e = useState([]), counties = _e[0], setCounties = _e[1];
    var _f = useState([]), municipalities = _f[0], setMunicipalities = _f[1];
    var fetchCountiesByState = function (stateAbbr) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchCountiesResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchCounties({ state_abbr: stateAbbr })];
                case 1:
                    fetchCountiesResponse = _a.sent();
                    setCounties(fetchCountiesResponse.result.counties);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchMunicipalitiesByState = function (stateAbbr) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchMunicipalitiesResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchMunicipalities({ state_abbr: stateAbbr })];
                case 1:
                    fetchMunicipalitiesResponse = _a.sent();
                    setMunicipalities(fetchMunicipalitiesResponse.result.municipalities);
                    return [2 /*return*/];
            }
        });
    }); };
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    var defaultValues = {};
    if (license) {
        defaultValues = {
            number: license.number,
            state_abbr: license.state.abbreviation,
            county_id: (_b = license.county) === null || _b === void 0 ? void 0 : _b.id,
            municipality_id: (_c = license.municipality) === null || _c === void 0 ? void 0 : _c.id,
            notes: license.notes,
            start_date: license.start_date,
            submission_date: license.submission_date,
            issued_date: license.issued_date,
            expiration_date: license.expiration_date,
        };
    }
    if (salesRepresentative) {
        defaultValues['sales_reps_ids'] = [salesRepresentative.id];
    }
    var methods = useForm({
        defaultValues: defaultValues,
        mode: 'all',
        reValidateMode: 'onChange',
        resolver: yupResolver(license ? editLicenseSchema : newLicenseSchema)
    });
    var handleSubmit = methods.handleSubmit, setValue = methods.setValue, getValues = methods.getValues, _g = methods.formState, isValid = _g.isValid, isDirty = _g.isDirty, errors = _g.errors, isSubmitting = _g.isSubmitting, register = methods.register, resetField = methods.resetField, watch = methods.watch;
    var handleChange = useCallback(function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        setValue(name, value, { shouldValidate: true, shouldDirty: true });
        if (name === 'state_abbr') {
            fetchCountiesByState(value);
            fetchMunicipalitiesByState(value);
            resetField('county_id');
            resetField('municipality_id');
        }
    }, [setValue, resetField]);
    var handlePreviewFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var response, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(file.id && license)) return [3 /*break*/, 2];
                    return [4 /*yield*/, previewLicenseAttachment(license.id, file.id)];
                case 1:
                    response = _a.sent();
                    url = URL.createObjectURL(response);
                    window.open(url, '_blank');
                    return [3 /*break*/, 3];
                case 2:
                    window.open(URL.createObjectURL(file), '_blank');
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDownloadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var attachment, response, url, link, asFile, url, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file.id) return [3 /*break*/, 2];
                    attachment = file;
                    return [4 /*yield*/, downloadLicenseAttachment(license === null || license === void 0 ? void 0 : license.id, attachment.id)];
                case 1:
                    response = _a.sent();
                    url = URL.createObjectURL(response);
                    link = document.createElement('a');
                    link.href = url;
                    link.download = attachment.filename;
                    link.click();
                    return [3 /*break*/, 3];
                case 2:
                    asFile = file;
                    url = URL.createObjectURL(asFile);
                    link = document.createElement('a');
                    link.href = url;
                    link.download = asFile.name;
                    link.click();
                    URL.revokeObjectURL(url);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmitLicenseFrom = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, createLicenseResponse, _i, _a, attachment, licensesResponse, e_1, updateLicenseResponse_1, attachmentIds, currentAttachmentIds_1, deletedAttachmentsIds, _b, _c, attachment, licensesResponse, error_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    values = getValues();
                    if (!!license) return [3 /*break*/, 7];
                    return [4 /*yield*/, createLicense({
                            sales_reps_ids: salesRepresentative ? [salesRepresentative.id] : values.sales_reps_ids,
                            number: values.number || null,
                            state_abbr: values.state_abbr,
                            county_id: values.county_id || null,
                            municipality_id: values.municipality_id || null,
                            expiration_date: moment(values.expiration_date).format(formatDate.FORMAT_REQUEST),
                            issued_date: moment(values.issued_date).format(formatDate.FORMAT_REQUEST),
                            notes: values.notes || null,
                            start_date: values.start_date ? moment(values.start_date).format(formatDate.FORMAT_REQUEST) : null,
                            submission_date: values.submission_date ? moment(values.submission_date).format(formatDate.FORMAT_REQUEST) : null,
                        })];
                case 1:
                    createLicenseResponse = _d.sent();
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 5, , 6]);
                    if (!createLicenseResponse.result.license_id) return [3 /*break*/, 4];
                    if (values.attachments && values.attachments.length > 0) {
                        for (_i = 0, _a = values.attachments; _i < _a.length; _i++) {
                            attachment = _a[_i];
                            uploadLicenseAttachment(createLicenseResponse.result.license_id, attachment);
                        }
                    }
                    if (!salesRepresentative) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchSalesRepresentativeLicenses(salesRepresentative.id)];
                case 3:
                    licensesResponse = _d.sent();
                    setSalesRepresentativeLicenses(licensesResponse.result.licenses);
                    _d.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _d.sent();
                    console.error(e_1);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 17];
                case 7: return [4 /*yield*/, updateLicense({
                        number: values.number || null,
                        state_abbr: values.state_abbr,
                        county_id: values.county_id || null,
                        municipality_id: values.municipality_id || null,
                        expiration_date: moment(values.expiration_date).format(formatDate.FORMAT_REQUEST),
                        issued_date: moment(values.issued_date).format(formatDate.FORMAT_REQUEST),
                        notes: values.notes || null,
                        start_date: values.start_date ? moment(values.start_date).format(formatDate.FORMAT_REQUEST) : null,
                        submission_date: values.submission_date ? moment(values.submission_date).format(formatDate.FORMAT_REQUEST) : null,
                    }, license.id)];
                case 8:
                    updateLicenseResponse_1 = _d.sent();
                    _d.label = 9;
                case 9:
                    _d.trys.push([9, 16, , 17]);
                    if (!(updateLicenseResponse_1.result.license_id && salesRepresentative)) return [3 /*break*/, 15];
                    if (!(values.attachments && values.attachments.length >= 0)) return [3 /*break*/, 13];
                    attachmentIds = selectedLicenseAttachments.map(function (attachment) { return attachment.id; });
                    currentAttachmentIds_1 = values.attachments.map(function (attachment) { return attachment.id; }).filter(function (id) { return id; });
                    deletedAttachmentsIds = attachmentIds.filter(function (attachmentId) { return !(currentAttachmentIds_1 === null || currentAttachmentIds_1 === void 0 ? void 0 : currentAttachmentIds_1.includes(attachmentId)); });
                    deletedAttachmentsIds.forEach(function (attachmentId) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, deleteLicenseAttachment(updateLicenseResponse_1.result.license_id, attachmentId)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    _b = 0, _c = values.attachments;
                    _d.label = 10;
                case 10:
                    if (!(_b < _c.length)) return [3 /*break*/, 13];
                    attachment = _c[_b];
                    if (!!attachment.id) return [3 /*break*/, 12];
                    return [4 /*yield*/, uploadLicenseAttachment(updateLicenseResponse_1.result.license_id, attachment)];
                case 11:
                    _d.sent();
                    _d.label = 12;
                case 12:
                    _b++;
                    return [3 /*break*/, 10];
                case 13: return [4 /*yield*/, fetchSalesRepresentativeLicenses(salesRepresentative === null || salesRepresentative === void 0 ? void 0 : salesRepresentative.id)];
                case 14:
                    licensesResponse = _d.sent();
                    setSalesRepresentativeLicenses(licensesResponse.result.licenses);
                    _d.label = 15;
                case 15: return [3 /*break*/, 17];
                case 16:
                    error_1 = _d.sent();
                    console.log(error_1);
                    return [3 /*break*/, 17];
                case 17:
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); }, [
        getValues,
        license,
        onClose,
        salesRepresentative,
        selectedLicenseAttachments,
        setSalesRepresentativeLicenses
    ]);
    useEffect(function () {
        if (license) {
            fetchCountiesByState(license.state.abbreviation);
            fetchMunicipalitiesByState(license.state.abbreviation);
        }
        else if (!salesRepresentative)
            loadSalesRepresentatives();
    }, [license, salesRepresentative]);
    var loadSalesRepresentatives = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchSalesRepresentativesResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchSalesRepresentativesList({})];
                case 1:
                    fetchSalesRepresentativesResponse = _a.sent();
                    setSalesRepresentatives(fetchSalesRepresentativesResponse.result.reps);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: "w-[576px]" }, { children: _jsx(FormProvider, __assign({}, methods, { children: _jsxs("form", __assign({ noValidate: true, onSubmit: handleSubmit(handleSubmitLicenseFrom) }, { children: [_jsx(LicenseHeader, { label: license ? EDIT_LICENSE : NEW_LICENSE, onClose: onClose }), _jsxs("div", __assign({ className: "px-6 grid grid-cols-1 py-6 gap-y-6 gap-x-4 sm:grid-cols-6 h-[473px] overflow-y-auto no-scrollbar" }, { children: [!license && !salesRepresentative && (_jsx(CustomFormElement, { id: 'sales_reps_ids', name: 'sales_reps_ids', label: REP_LABEL, type: "multiSelect", isMulti: true, options: salesRepresentatives.map(function (salesRepresentative) { return ({
                                    value: salesRepresentative.id,
                                    label: salesRepresentative.name,
                                }); }), onChange: handleChange, value: getValues('sales_reps_ids'), register: register, error: errors === null || errors === void 0 ? void 0 : errors.sales_reps_ids, formElementWrapperClassName: 'sm:col-span-6', placeholder: 'Select employee', required: true })), _jsx(CustomFormElement, { id: 'state_abbr', name: 'state_abbr', label: STATE_LABEL, type: "select", selectOptions: __spreadArray([], states.map(function (state) { return ({
                                    value: state.abbreviation,
                                    name: state.name
                                }); }), true), onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.state_abbr, formElementWrapperClassName: 'sm:col-span-2', searchable: true, required: true }), _jsx(CustomFormElement, { id: 'county_id', name: 'county_id', label: COUNTY_LABEL, type: "select", selectOptions: __spreadArray([], counties.map(function (county) { return ({
                                    value: county.id,
                                    name: capitalize(county.name)
                                }); }), true), onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.county_id, formElementWrapperClassName: 'sm:col-span-2', searchable: true, disabled: counties.length === 0 }), _jsx(CustomFormElement, { id: 'municipality_id', name: 'municipality_id', label: MUNICIPALITY_LABEL, type: "select", selectOptions: __spreadArray([], municipalities.map(function (municipality) { return ({
                                    value: municipality.id,
                                    name: capitalize(municipality.name)
                                }); }), true), onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.municipality_id, formElementWrapperClassName: 'sm:col-span-2', dropdownPosition: 'left', searchable: true, disabled: municipalities.length === 0 }), _jsx(CustomFormElement, { id: 'number', name: 'number', label: LICENSE_NUMBER_LABEL, placeholder: LICENSE_NUMBER_PLACEHOLDER, type: "text", onChange: handleChange, register: register, error: errors === null || errors === void 0 ? void 0 : errors.number, formElementWrapperClassName: 'sm:col-span-6' }), _jsx(CustomFormElement, { id: 'start_date', name: 'start_date', label: START_DATE_LABEL, type: "date", onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.start_date, formElementWrapperClassName: 'sm:col-span-3' }), _jsx(CustomFormElement, { id: 'submission_date', name: 'submission_date', label: SUBMISSION_DATE_LABEL, type: "date", onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.submission_date, formElementWrapperClassName: 'sm:col-span-3', dropdownPosition: 'left' }), _jsx(CustomFormElement, { id: 'issued_date', name: 'issued_date', label: ISSUED_DATE_LABEL, type: "date", onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.issued_date, formElementWrapperClassName: 'sm:col-span-3', required: true }), _jsx(CustomFormElement, { id: 'expiration_date', name: 'expiration_date', label: EXPIRATION_DATE_LABEL, type: "date", onChange: handleChange, register: register, watch: watch, error: errors === null || errors === void 0 ? void 0 : errors.expiration_date, formElementWrapperClassName: 'sm:col-span-3', required: true, dropdownPosition: 'left' }), _jsx(CustomFormElement, { id: 'notes', name: 'notes', label: NOTES_LABEL, placeholder: NOTES_PLACEHOLDER, rows: 1, type: "textArea", onChange: handleChange, register: register, error: errors === null || errors === void 0 ? void 0 : errors.notes, formElementWrapperClassName: 'sm:col-span-6' }), _jsx(CustomFormElement, __assign({ id: 'attachments', name: 'attachments', type: "file", attachmentLabel: ATTACHMENTS_LABEL, attachmentDescription: ATTACHMENTS_DESCRIPTION, acceptedFileTypes: ['application/pdf', 'image/jpeg', 'image/png'], maxFileSize: 30 * 1024 * 1024, maxFileCount: 5, defaultFiles: getValues('attachments'), onChange: handleChange, register: register }, (license && { selectedLicenseAttachments: selectedLicenseAttachments }), { onPreviewFile: handlePreviewFile, onDownloadFile: handleDownloadFile, formElementWrapperClassName: 'sm:col-span-6' }))] })), _jsx(LicenseFooter, { onCancel: onClose, onSave: function () { }, isValid: isValid, isDirty: isDirty, isSubmitting: isSubmitting })] })) })) })));
};
export default LicenseForm;
